<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Route Edit</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="form-group form-row required">
                <label class="col-form-label col-sm-3">Asal</label>
                <div class="col-sm-9">
                  <multiselect
                      v-model="originRoutes"
                      :options="optionsAreaOrigin"
                      placeholder="Pilih asal"
                      :searchable="true"
                      :close-on-select="true"
                      :multiple="false"
                      :show-labels="false"
                      :custom-label="customLabel"
                      @open="loadAllOrigin"
                      @search-change="handleSearchOrigin"
                      @input="handleOriginRouteCode"
                  />
                  <div
                      v-if="!routesData.origin_routes_id && !validate.origin_routes_id.isValid"
                      class="invalid-feedback d-block"
                  >
                    {{ validate.origin_routes_id.message }}
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="form-group form-row required">
                <label class="col-form-label col-sm-3">Tujuan</label>
                <div class="col-sm-9">
                  <multiselect
                      v-model="destinationRoutes"
                      :options="optionsAreaDestination"
                      placeholder="Pilih tujuan"
                      :searchable="true"
                      :show-labels="false"
                      :multiple="false"
                      :close-on-select="true"
                      :custom-label="customLabel"
                      @open="loadAllDestination"
                      @search-change="handleSearchDestination"
                      @input="handleDestinationRouteCode"
                  />

                  <div
                      v-if="!routesData.destination_routes_id && !validate.destination_routes_id.isValid"
                      class="invalid-feedback d-block"
                  >
                    {{ validate.destination_routes_id.message }}
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="form-group form-row required">
                <label class="col-form-label col-sm-3">Slug URL otomatis</label>
                <div class="col-sm-9">
                  <input
                      class="form-control"
                      type="text"
                      disabled
                      :value="routesData.slug"
                      placeholder="Slug URL otomatis"
                  />
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="form-group form-row required">
                <label class="col-form-label col-sm-3">Title Page</label>
                <div class="col-sm-9">
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Title Page"
                      v-model="routesData.title"
                      :class="{ 'is-invalid': showErrorField && !validate.title.isValid }"
                  />
                  <div v-if="showErrorField && !validate.title.isValid"
                       class="invalid-feedback d-block">
                    {{ validate.title.message }}
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="form-group form-row required">
                <label class="col-form-label col-sm-3">Meta Description</label>
                <div class="col-sm-9">
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Meta Description"
                      v-model="routesData.meta_description"
                      :class="{ 'is-invalid': showErrorField && !validate.meta_description.isValid }"
                  />
                  <div v-if="showErrorField && !validate.meta_description.isValid"
                       class="invalid-feedback d-block">
                    {{ validate.meta_description.message }}
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="form-group form-row required">
                <label class="col-form-label col-sm-3">Status</label>
                <div class="col-sm-9">
                  <select
                      class="form-control"
                      v-model="routesData.status"
                      :class="{ 'is-invalid': showErrorField && !validate.status.isValid }"
                      @change="handleStatus"
                  >
                    <option disabled value="">Pilih status</option>
                    <option value="active">ACTIVE</option>
                    <option value="inactive">INACTIVE</option>
                  </select>

                  <div v-if="showErrorField && !validate.status.isValid"
                       class="invalid-feedback d-block">
                    {{ validate.status.message }}
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInputFile
                label="Meta Image"
                class="required"
                horizontal
                type="file"
                @change="handleImageIllustration"
              />
              File size should be below 250KB.
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="routesData.image_illustration" :src="routesData.image_illustration" />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="$router.go(-1)">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                  color="success"
                  class="float-right"
                  @click="handleSave"
              >
                Update
              </CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from "vue-multiselect";
import RoutesUseCase from "./app/usecase/index.js";
import debounce from "lodash/debounce";

export default {
  name: "RouteEdit",
  components: {Multiselect},
  data() {
    return {
      originRoutes: null,
      destinationRoutes: null,

      originSearchQuery: "",
      destinationSearchQuery: "",

      routesData: {
        origin_routes_id: "",
        destination_routes_id: "",
        slug: "",
        title: "",
        meta_description: "",
        status: "",
        image_illustration: null,
        image_illustrationUrl: null,
      },

      optionsAreaOrigin: [],
      optionsAreaDestination: [],
      optionsActiveStatus: [
        {label: "ACTIVE", value: "active"},
        {label: "INACTIVE", value: "inactive"},
      ],

      showErrorField: false,
      fixedPrefix: "cek-ongkir-",
    };
  },

  computed: {
    validate() {
      return {
        origin_routes_id: {
          isValid: this.routesData.origin_routes_id ? true : false,
          message: "Area asal harus diisi",
        },
        destination_routes_id: {
          isValid: this.routesData.destination_routes_id ? true : false,
          message: "Area tujuan harus diisi",
        },
        title: {
          isValid: this.routesData.title ? true : false,
          message: "Title harus diisi",
        },
        meta_description: {
          isValid: this.routesData.meta_description ? true : false,
          message: "Meta Description harus diisi",
        },
        status: {
          isValid: this.routesData.status ? true : false,
          message: "Status harus diisi",
        },
        image_illustration: {
          isValid: this.routesData.image_illustration ? true : false,
          message: "Meta image harus diisi",
        },
      };
    },
  },

  methods: {
    handleImageIllustration(value) {
      const file = value[0];
      this.routesData.image_illustration = URL.createObjectURL(file);
      this.routesData.image_illustrationUrl = file;
    },
    async loadAllOrigin() {
      const {data} = await RoutesUseCase.getLocations("q=");
      this.optionsAreaOrigin = data.map(d => ({
        label: d.route_code,
        value: d.route_id,
      }));
    },
    async loadAllDestination() {
      const {data} = await RoutesUseCase.getLocations("q=");
      this.optionsAreaDestination = data.map(d => ({
        label: d.route_code,
        value: d.route_id,
      }));
    },
    handleSearchOrigin(value) {
      if (value === "") {
        this.loadAllOrigin();
        return;
      }
      this.getLocations(value, "origin");
    },

    handleSearchDestination: debounce(function (value) {
      if (value === "") return;
      this.destinationSearchQuery = value;
      this.getLocations(value, "destination");
    }, 300),

    async getLocations(query, type) {
      const q = `q=${encodeURIComponent(query)}`;
      const {data} = await RoutesUseCase.getLocations(q);

      if (!data) return;

      const options = data.map((d) => ({
        label: d.route_code,
        value: d.route_id,
      }));

      if (type === "origin") this.optionsAreaOrigin = options;
      if (type === "destination") this.optionsAreaDestination = options;
    },

    handleOriginRouteCode(item) {
      this.routesData.origin_routes_id = item.value;
      this.originRoutes = item;
      this.routesData.slug = this.generateSlugBySelectedArea();
    },

    handleDestinationRouteCode(item) {
      this.routesData.destination_routes_id = item.value;
      this.destinationRoutes = item;
      this.routesData.slug = this.generateSlugBySelectedArea();
    },

    generateSlugBySelectedArea() {
      if (!this.originRoutes || !this.destinationRoutes) return "";

      const origin = this.originRoutes.label;
      const destination = this.destinationRoutes.label;

      const clean = (str) =>
          str
              .replace(/\([^)]*\)/g, "")
              .replace(/,/g, "")
              .trim()
              .toLowerCase()
              .replace(/\s+/g, "-");

      return `${this.fixedPrefix}${clean(origin)}-ke-${clean(destination)}`;
    },

    handleStatus(e) {
      this.routesData.status = e.target.value;
    },

    handleSave() {
      this.showErrorField = true;

      if (
          !this.validate.origin_routes_id.isValid ||
          !this.validate.destination_routes_id.isValid ||
          !this.validate.title.isValid ||
          !this.validate.meta_description.isValid ||
          !this.validate.status.isValid ||
          !this.validate.image_illustration.isValid 
      ) {
        this.$swal.fire({
          icon: "error",
          html: `<h4>Harap lengkapi semua field wajib</h4>`,
        });
        return;
      }

      this.processSave();
    },

    async processSave() {
      try {
        // const payload = {
        //   ...this.routesData,
        // };

        // const {err} = await RoutesUseCase.update(this.$route.params.id, payload);

        const formData = new FormData();
        formData.append("origin_routes_id", this.routesData.origin_routes_id);
        formData.append("destination_routes_id", this.routesData.destination_routes_id);
        formData.append("slug", this.routesData.slug);
        formData.append("title", this.routesData.title);
        formData.append("meta_description", this.routesData.meta_description);
        formData.append("status", this.routesData.status);
        if (this.routesData.image_illustrationUrl) {
          formData.append(
            "image_illustration",
            this.routesData.image_illustrationUrl
          );
        }

        const { err } = await RoutesUseCase.update(this.$route.params.id, formData);

        if (err) {
          this.$swal.fire({icon: "error", text: err});
        } else {
          this.$swal.fire({icon: "success", text: "Route updated"});
          this.$router.push("/management/routes");
        }
      } catch (error) {
        this.$swal.fire({icon: "error", text: error.message});
      }
    },

    customLabel(item) {
      return `${item.label}`;
    },
  },

  async mounted() {
    const {data} = await RoutesUseCase.getById(this.$route.params.id);

    this.routesData = {
      origin_routes_id: data.origin_routes_id,
      destination_routes_id: data.destination_routes_id,
      slug: data.slug,
      title: data.title,
      meta_description: data.meta_description,
      status: data.status,
      image_illustration: data.image_illustration,
    };

    this.originRoutes = {
      value: data.origin_routes_id,
      label: data.origin_route.route_code,
      fullLabel: `${data.origin_route.route_code}`
    };

    this.destinationRoutes = {
      value: data.destination_routes_id,
      label: data.destination_route.route_code,
      fullLabel: `${data.destination_route.route_code}`
    };

    this.optionsAreaOrigin = [this.originRoutes];
    this.optionsAreaDestination = [this.destinationRoutes];
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins&display=swap");
@import "./Routes.css";
.image-ilustrasi {
  height: 120px;
}
@media(min-width:768px) {
  .image-ilustrasi {
    height: 200px;
    margin-left: 25%;
  }
}
</style>
<style scoped>
.form-group.required .col-form-label::after {
  content: "*";
  color: red;
}

.form-row.required .col-form-label::after {
  content: "*";
  color: red;
}

.custom-select option:checked::before,
.custom-select option:checked::after {
  display: none !important;
  background-image: none !important;
  content: "" !important;
}
</style>
